import type { RouteItem } from '@web/common/src/routes';
import { lazy } from 'react';
import { bmUrlPrefix } from './utils';

// Bill Management
const BillMgmtV2 = lazy(() => import('@/pages/BillMgmt'));
const OtherRoutes = lazy(() => import('@/pages/KKC/banks'));

console.log(import.meta.env.VITE_APP_TARGET);

const routes: RouteItem[] = [
  {
    path: `${bmUrlPrefix}/billMgmtv2/*`,
    component: <BillMgmtV2 />,
    meta: {
      name: '账单管理',
    },
  },
  {
    path: '*',
    component: <OtherRoutes />,
    meta: {
      name: '其他路由页面',
    },
  },
];

export default routes;
